let storyJson = {
    "_id": "631de9d842a88e000b8c9a3f",
    "createdAt": "",
    "updatedAt": "",
    "userId": "00u3g7b729pWSK9GX5d7",
    "lastUpdateUserEmail": "adia@storydoc.com",
    "layoutVersion": "4.0.0",
    "orgId": "1bebc2d8c1978a699d11adbb160cc4a3",
    "status": "Draft",
    "previewUrl": "https://www-staging.storydoc.com/preview/5d7d8922e00d9265/62cbdb85a60dfc000acd236e/1657527173804",
    "settings": {
        "designSystemV2": {
            "backgroundColor": "#FFFFFF",
            "backgroundColor2": "#FFFBFB",
            "buttonBackgroundColor": "#1D0E22",
            "buttonBackgroundHoverColor": "#C0ACC6",
            "buttonColor": "#FFFFFF",
            "buttonHoverColor": "#1D0E22",
            "buttonRadius": "25px",
            "font": "Roboto",
            "highlightColor": "#C0ACC6",
            "highlightTextColor": "#2F2F2F",
            "hyperlinkColor": "#0177CC",
            "hyperlinkHoverColor": "#00406D",
            "mobileParagraphFontSize": "16px",
            "mobileSubtitleFontSize": "20px",
            "mobileTitleFontSize": "36px",
            "paragraphColor": "#313131",
            "paragraphFont": "Roboto",
            "paragraphFontSize": "18px",
            "paragraphMargin": "12px",
            "paragraphStyle": 400,
            "primaryColor": "#622F70",
            "rkpiFontSize": "100%",
            "secondaryColor": "#C0ACC6",
            "subtitleColor": "#313131",
            "subtitleFont": "Roboto",
            "subtitleFontSize": "28px",
            "subtitleMargin": "12px",
            "subtitleStyle": 700,
            "theme": "storydoc.com (26/05/2022 14:29)",
            "themeColor3": "#1D0E22",
            "themeColor4": "#F5AA41",
            "titleColor": "#313131",
            "titleFont": "Roboto",
            "titleFontSize": "40px",
            "titleMargin": "32px",
            "titleStyle": 700
        },
        "canonical":"48b04515-156a-4d2d-898f-d798f50c41af",
        "favicon": "https://assets-staging.storydoc.com/5d7d8922e00d9265/d3ac8eb3-a59e-44fc-a4ef-06c97f85c2ac",
        "fs": {
            "fs-vars": "[]"
        },
        "jwtTokenIat": null,
        "localWorkspace": "",
        "og": {
            "description": "Check out my interactive Storydoc presentation",
            "image": "https://assets-staging.storydoc.com/72580ed1d47efca1d73a6447c315ba51/6a6412fc-5c35-4441-8835-0e3955a19088",
            "locale": "en_US",
            "siteName": "New Template title test"
        },
        "seoEnabled": true,
        "template": {
            "defaultCoverVideo": false,
            "isStartFromWebsiteFlow": false,
            "isWizardFlow": false,
            "selectedTemplateName": "Blank template",
            "templateCategory": "Popular",
            "themeDesignStatus": "Default theme"
        },
        "title": "My Storydoc #689",
        "cssUrl": "https://assets-staging.storydoc.com/5d7d8922e00d9265/stylesheet/staging/e8f81147-07bb-4f94-b583-443579944d62/layout-preview.css"
    },
    "slides": [
        {
            "settings": {
                "verticalAlignment": "center",
                "horizontalAlignment": "center",
                "minHeight": "auto",
                "isCustomHeight": false,
                "maxWidth": "narrow",
                "backgroundType": "image",
                "backgroundColor": "#F3E8FC",
                "overlayOpacity": "20",
                "backgroundImage": "https://assets.storydoc.com/e128f0e44fb5e9d89f8139f0d557c563/d0767e15-a444-44fb-b930-5b036b1868a1",
                "gradient": "Linear",
                "isHidden": false,
                "analytics": "ANALYTICS EVENT NAME"
            },
            "combos": [
                {
                    "name": "Simple",
                    "settings": {
                        "verticalAlignment": "center",
                        "horizontalAlignment": "center",
                        "backgroundColor": "transparent",
                        "borderColor": "transparent",
                        "borderWidth": 1,
                        "round": '8px',
                        "minHeight": 'auto',
                        "isCustomHeight": false,
                        "maxWidth": 'large',
                        "isCustomWidth": false,
                        "setsPerLine":'1',
                        "setsSpace": '16',
                    },
                    "sets": [
                        {
                            "horizontalAlignment": "inherit",
                            "verticalAlignment": "inherit",
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3>",
                                            "content": "<h2 style=\"text-align: center;\">Insert your main title here</h2>"
                                        }
                                    }
                                ],
                                []
                            ]
                        }
                    ]
                },
                {
                    "name": "Array",
                    "settings": {
                        "verticalAlignment": "center",
                        "horizontalAlignment": "center",
                        "backgroundColor": "transparent",
                        "borderColor": "transparent",
                        "borderWidth": 1,
                        "round": '8px',
                        "minHeight": 'auto',
                        "isCustomHeight": false,
                        "maxWidth": 'large',
                        "isCustomWidth": false,
                        "setsPerLine":'3',
                        "setsSpace": '16',
                    },
                    "sets": [
                        {
                            "horizontalAlignment": "inherit",
                            "verticalAlignment": "inherit",
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://storage.googleapis.com/assets-staging.storydoc.com/editorv4/comboImage1.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": false,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "50",
                                        }
                                    },
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Who We Are?</h2><p>Drive TLV hosts, grows and fosters top Israeli startups and entrepreneurs while providing sponsoring organizations with the opportunity to participate in Israel’s cutting-edge Smart Mobility technology revolution</p>"
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "verticalAlignment": "inherit",
                            "horizontalAlignment": "inherit",
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://assets-staging.storydoc.com/editorv4/comboImage2.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": true,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "50",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Smart Mobility Era</h2><p>The concept of mobility is constantly evolving. The goal of carrying a person or goods from a certain place to another is no longer relying solely on the automotive industry.</p>"
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "verticalAlignment": "inherit",
                            "horizontalAlignment": "inherit",
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://assets-staging.storydoc.com/editorv4/comboImage3.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": true,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "50",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Power By Drive</h2><p>POWER is Drive TLV’s new testing, evaluation, and development center, enabling an efficient and expedited validation of Israeli technologies - here and now.</p>"
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ],
                            "tabs": [
                                {
                                    "name": "content",
                                    "path": "Richtext/Richtext",
                                    "data": {
                                        "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                        "content": "<h2>Who We Are?</h2><p>Drive TLV hosts, grows and fosters top Israeli startups and entrepreneurs while providing sponsoring organizations with the opportunity to participate in Israel’s cutting-edge Smart Mobility technology revolution</p>"
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "settings": {
                "verticalAlignment": "center",
                "horizontalAlignment": "center",
                "minHeight": "auto",
                "isCustomHeight": false,
                "maxWidth": "narrow",
                "backgroundType": "backgroundColor",
                "overlayOpacity": "20",
                "backgroundImage": "",
                "gradient": "Linear",
                "isHidden": false,
                "analytics": "ANALYTICS EVENT NAME"
            },
            "combos": [
                {
                    "name": "Simple",
                    "settings": {
                        "maxWidth": "70",
                        "verticalAlignment": "center",
                        "horizontalAlignment": "center",
                        "backgroundColor": "transparent",
                        "borderColor": "transparent",
                        "borderWidth": 1,
                        "round": '8px',
                        "minHeight": 'auto',
                        "isCustomHeight": true,
                        "isCustomWidth": false,
                        "setsPerLine":'4',
                        "setsSpace": '16',
                    },
                    "sets": [
                        {
                            "horizontalAlignment": "inherit",
                            "verticalAlignment": "inherit",
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3>",
                                            "content": "<h2 style=\"text-align: center;\">Insert your main title here</h2>"
                                        }
                                    }
                                ],
                                []
                            ]
                        }
                    ]
                },
                {
                    "name": "SideBySide",
                    "settings": {
                        "maxWidth": "100",
                        "verticalAlignment": "center",
                        "horizontalAlignment": "center",
                        "backgroundColor": "transparent",
                        "borderColor": "transparent",
                        "borderWidth": 1,
                        "round": '8px',
                        "minHeight": 'auto',
                        "isCustomHeight": true,
                        "isCustomWidth": false,
                        "setsPerLine":'1',
                        "setsSpace": '16',
                    },
                    "sets": [
                        {
                            "horizontalAlignment": "inherit",
                            "verticalAlignment": "inherit",
                            "isGroupRatioSet":true,
                            "groupsRatio": [
                                "50",
                                "50"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Who We Are?</h2><p>Drive TLV hosts, grows and fosters top Israeli startups and entrepreneurs while providing sponsoring organizations with the opportunity to participate in Israel’s cutting-edge Smart Mobility technology revolution</p>"
                                        }
                                    },
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://storage.googleapis.com/assets-staging.storydoc.com/editorv4/comboImage3.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": false,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "70",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                ]
                            ]
                        },
                        {
                            "horizontalAlignment": "inherit",
                            "verticalAlignment": "inherit",
                            "isGroupRatioSet":true,
                            "groupsRatio": [
                                "50",
                                "50"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://storage.googleapis.com/assets-staging.storydoc.com/editorv4/comboImage3.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": false,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "70",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                ],
                                [
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Who We Are?</h2><p>Drive TLV hosts, grows and fosters top Israeli startups and entrepreneurs while providing sponsoring organizations with the opportunity to participate in Israel’s cutting-edge Smart Mobility technology revolution</p>"
                                        }
                                    },
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ]
                        },
                    ],
                }
            ]
        },
        {
            "settings": {
                "verticalAlignment": "center",
                "horizontalAlignment": "center",
                "minHeight": "auto",
                "isCustomHeight": false,
                "maxWidth": "narrow",
                "backgroundType": "backgroundColor",
                "backgroundColor": "#F3E8FC",
                "overlayOpacity": "20",
                "backgroundImage": "",
                "gradient": "Linear",
                "isHidden": false,
                "analytics": "ANALYTICS EVENT NAME"
            },
            "combos": [
                {
                    "name": "Array",
                    "settings": {
                        "maxWidth": "50",
                        "backgroundColor": "transparent",
                        "borderColor": "transparent",
                        "borderWidth": 1,
                        "round": '8px',
                        "setsPerLine":'3',
                        "setsSpace": '16',
                    },
                    "sets": [
                        {
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://storage.googleapis.com/assets-staging.storydoc.com/editorv4/comboImage3.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": false,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "70",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Who We Are?</h2><p>Drive TLV hosts, grows and fosters top Israeli startups and entrepreneurs while providing sponsoring organizations with the opportunity to participate in Israel’s cutting-edge Smart Mobility technology revolution</p>"
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://assets-staging.storydoc.com/editorv4/comboImage2.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": true,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "70",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Smart Mobility Era</h2><p>The concept of mobility is constantly evolving. The goal of carrying a person or goods from a certain place to another is no longer relying solely on the automotive industry.</p>"
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "isGroupRatioSet":false,
                            "groupsRatio": [
                                "100",
                                "100"
                            ],
                            "groups": [
                                [
                                    {
                                        "name": "Image",
                                        "data": {
                                            "src": "https://assets-staging.storydoc.com/editorv4/comboImage1.png",
                                            "alt": "dfsdsfdsfdsfds",
                                            "isShadow": true,
                                            "shadowColor": "#00000025",
                                            "round": "100%",
                                            "width": "70",
                                            "verticalAlignment": "inherit",
                                            "horizontalAlignment": "inherit",
                                        }
                                    },
                                    {
                                        "name": "RichText",
                                        "data": {
                                            "defaultContent": "<h3><strong>Insert your image title here</strong></h3><p>Add here description of the image or other content that will be presented near it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pellentesque molestie bibendum. Nunc sollicitudin lacus sit amet ex bibendum semper.</p>",
                                            "content": "<h2>Power By Drive</h2><p>POWER is Drive TLV’s new testing, evaluation, and development center, enabling an efficient and expedited validation of Israeli technologies - here and now.</p>"
                                        }
                                    }
                                ],
                                [
                                    {
                                        "name": "Button",
                                        "data": {
                                            "title": "Click Here",
                                            "url": "#",
                                            "target": "_blank",
                                            "fontSize": "14",
                                            "borderWidth" : "1",
                                            "minWidth" : "0",
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}


export default storyJson;
